module.exports = __webpack_public_path__ + "img/US Police Bus Parking.d03ab0d7.png";